// App.js - WEB
import React, {PureComponent} from "react";
import {View, Text, Button, FlatList, TouchableOpacity, Linking, Platform, I18nManager} from "react-native";
//import {ModalContainer} from "react-router-modal";
import {connect, Provider} from "react-redux";
import store from "../../redux/store";
import HomeScreen from "../../web/screens/HomeScreen";
import {
    NavigationContainer,
    DefaultTheme as NavigationDefaultTheme,
    DarkTheme as NavigationDarkTheme,
    LinkingOptions
} from '@react-navigation/native';
import {createDrawerNavigator} from '@react-navigation/drawer';
import SecondScreen from "../../web/screens/SecondScreen";
import {createStackNavigator} from '@react-navigation/stack';
import {createBottomTabNavigator} from '@react-navigation/bottom-tabs';

import {enableScreens} from 'react-native-screens';
import SplashSatiaScreen, {
    serviceActionAccount,
    serviceActionSetConnectionInternetHotspot,
    serviceActionSetIsConnected,
    serviceActionSetToken,
    serviceActionSetUser,
    serviceActionSetUserPassWifi,
    serviceActionSetwifiConnectionStatus,
    serviceActionSetwifiIsEnabled,
    serviceActionTokenFirebase
} from "../../screens/satia/splash/action/ActionSplashSatiaScreen";
import AsyncStorage from '@react-native-community/async-storage';
import LoginEnterPhoneCodeSatiaScreen
    from "../../screens/satia/login/enterMobile/action/ActionLoginEnterPhoneCodeSatiaScreen";
import EnterCodeSatiaScreen from "../../screens/satia/login/enterCode/action/ActionEnterCodeSatiaScreen";

import {typeExport} from "../../redux/store/type";
// import RNRestart from 'react-native-restart';
// import i18n from "../../I18n/i18n";
import {navigationRef} from "../../redux/NavigationService";
import ListAccountSatiaScreen from "../../screens/satia/listAccount/ListAccountSatiaScreen";
import MainSatiaScreen from "../../screens/satia/main/MainSatiaScreen";
import MenuDrawerSatia from "../../drawer/right/MenuDrawerSatia";
import {AsyngStorageClass} from "../../tools/AsyngStorageClass";
import ListServiceSatiaScreen from "../../screens/satia/main/listService/ListServiceSatiaScreen";
import ListGigSatiaScreen from "../../screens/satia/main/listGigs/ListGigSatiaScreen";
import PaySatiaScreen from "../../screens/satia/main/pay/action/ActionPaySatiaScreen";
import ListMicroConsumptionSatiaScreen
    from "../../screens/satia/main/internetUsage/action/ActionListMicroConsumptionSatiaScreen";
import ContactUsScreen from "../../screens/common/contactUs/ContactUsScreen";
import TestConnectionScreen from "../../screens/satia/main/testConnection/TestConnectionScreen";
import ListHistoryTelephoneLineStatusSatiaScreen
    from "../../screens/satia/main/listHistoryLineStatus/action/ActionListHistoryTelephoneLineStatusSatiaScreen";
import ListServiceHistorySatiaScreen
    from "../../screens/satia/main/listServiceHistory/action/ActionListServiceHistorySatiaScreen";
import ListMessageSatiaScreen from "../../screens/satia/main/listMessage/action/ActionListMessageSatiaScreen";
import ListOnlineChargingHistorySatiaScreen
    from "../../screens/satia/main/listHistoryBuyCredit/action/ActionListOnlineChargingHistorySatiaScreen";
import ListMessageOperatorSatiaScreen
    from "../../screens/satia/main/listMessageOperation/action/ActionListMessageOperatorSatiaScreen";
import ListQuestionAndAnswerSatiaScreen
    from "../../screens/satia/main/listMessageOperation/action/ActionListQuestionAndAnswerSatiaScreen";
import ChangeInformationSatiaScreen from "../../screens/satia/main/profile/action/ActionChangeInformationSatiaScreen";
import ProfileSatiaScreen from "../../screens/satia/main/profile/ProfileSatiaScreen";
import UploadDocumentSatiaScreen from "../../screens/satia/main/profile/action/ActionUploadDocumentSatiaScreen";
import ShowListMicroConsumptionSatiaScreen
    from "../../screens/satia/main/internetUsage/ShowListMicroConsumptionSatiaScreen";
import SatiaScreen from "../../screens/common/contactUs/SatiaScreen";
import ChartSatiaScreen from "../../screens/satia/main/chart/ChartSatiaScreen";
import ShowMap from "../../screens/common/map/ShowMap";
import WebViewScreen from "../../screens/common/webview/WebViewScreen";
import ListVirtualBankSatiaScreen from "../../screens/satia/main/virtualBank/action/ActionListVirtualBankSatiaScreen";
//import DetailsGalleryServiceScreen from "../../screens/137/main/applay/DetailsGalleryServiceScreen";
import HelpSoftwareSatiaScreen from "../../screens/satia/main/helpSoftware/HelpSoftwareSatiaScreen";

import InformationSatiaScreen from "../../screens/satia/login/information/action/ActionInformationSatiaScreen";
import IntroduceFriendsSatiaScreen from "../../screens/satia/main/introduceFriends/IntroduceFriendsSatiaScreen";
import IntroduceFriendsChildSatiaScreen
    from "../../screens/satia/main/introduceFriends/IntroduceFriendsChildSatiaScreen";

//import InformationSatiaHookScreen from "../../screens/satia/login/information/InformationSatiaHookScreen";
import FactorServiceHistorySatiaScreen
    from "../../screens/satia/main/listServiceHistory/FactorServiceHistorySatiaScreen";


//import {Redirect} from "./Redirect";
import wifi from "../../importCalss/wifi";
import {serviceActionSetConnectionType} from "../../screens/137/splash/action/ActionSplashGetAllData";
import NetInfo from "@react-native-community/netinfo" ;
import axios from "axios" ;
import HMLoading from "../../customviews/HMLoading";
import TasksOperationSatiaScreen from "../../screens/satia/main/operation/TasksOperationSatiaScreen";
import AddTaskOperationSatiaScreen from "../../screens/satia/main/operation/action/ActionAddTaskOperationSatiaScreen";
import ListTaskOperationSatiaScreen from "../../screens/satia/main/operation/action/ActionListTaskOperationSatiaScreen";
import DetailsTaskOperationSatiaScreen from "../../screens/satia/main/operation/action/ActionDetailsTaskOperationSatiaScreen";
import LoginEnterUsernameSatiaScreen from "../../screens/satia/login/enterUsername/action/ActionLoginEnterUsernameSatiaScreen";
import HotSpotScreen from "../../screens/common/hotspot/HotSpotScreen";
import IncreaseCreditSatiaScreen from "../../screens/satia/main/virtualBank/action/ActionIncreaseCreditSatiaScreen";
import i18n from "../../I18n/i18n";

//
// const ListAccountSatiaScreen = React.lazy(() => import( "../../screens/satia/listAccount/ListAccountSatiaScreen"));
// const MainSatiaScreen = React.lazy(() => import( "../../screens/satia/main/MainSatiaScreen"));
// const MenuDrawerSatia = React.lazy(() => import( "../../drawer/right/MenuDrawerSatia"));
// const ListServiceSatiaScreen = React.lazy(() => import( "../../screens/satia/main/listService/ListServiceSatiaScreen"));
// const ListGigSatiaScreen = React.lazy(() => import( "../../screens/satia/main/listGigs/ListGigSatiaScreen"));
// const PaySatiaScreen = React.lazy(() => import( "../../screens/satia/main/pay/action/ActionPaySatiaScreen"));
// const ListMicroConsumptionSatiaScreen = React.lazy(() => import( "../../screens/satia/main/internetUsage/action/ActionListMicroConsumptionSatiaScreen"));
// const ContactUsScreen = React.lazy(() => import( "../../screens/common/contactUs/ContactUsScreen"));
// const TestConnectionScreen = React.lazy(() => import( "../../screens/satia/main/testConnection/TestConnectionScreen"));
// const ListHistoryTelephoneLineStatusSatiaScreen = React.lazy(() => import( "../../screens/satia/main/listHistoryLineStatus/action/ActionListHistoryTelephoneLineStatusSatiaScreen"));
// const ListServiceHistorySatiaScreen = React.lazy(() => import( "../../screens/satia/main/listServiceHistory/action/ActionListServiceHistorySatiaScreen"));
// const ListMessageSatiaScreen = React.lazy(() => import( "../../screens/satia/main/listMessage/action/ActionListMessageSatiaScreen"));
// const ListOnlineChargingHistorySatiaScreen = React.lazy(() => import( "../../screens/satia/main/listHistoryBuyCredit/action/ActionListOnlineChargingHistorySatiaScreen"));
// const ListMessageOperatorSatiaScreen = React.lazy(() => import( "../../screens/satia/main/listMessageOperation/action/ActionListMessageOperatorSatiaScreen"));
// const ListQuestionAndAnswerSatiaScreen = React.lazy(() => import( "../../screens/satia/main/listMessageOperation/action/ActionListQuestionAndAnswerSatiaScreen"));
// const ChangeInformationSatiaScreen = React.lazy(() => import( "../../screens/satia/main/profile/action/ActionChangeInformationSatiaScreen"));
// const ProfileSatiaScreen = React.lazy(() => import( "../../screens/satia/main/profile/ProfileSatiaScreen"));
// const UploadDocumentSatiaScreen = React.lazy(() => import( "../../screens/satia/main/profile/action/ActionUploadDocumentSatiaScreen"));
// const ShowListMicroConsumptionSatiaScreen = React.lazy(() => import( "../../screens/satia/main/internetUsage/ShowListMicroConsumptionSatiaScreen"));
// const SatiaScreen = React.lazy(() => import( "../../screens/common/contactUs/SatiaScreen"));
// const ChartSatiaScreen = React.lazy(() => import( "../../screens/satia/main/chart/ChartSatiaScreen"));
// const ShowMap = React.lazy(() => import( "../../screens/common/map/ShowMap"));
// const WebViewScreen = React.lazy(() => import( "../../screens/common/webview/WebViewScreen"));
// const ListVirtualBankSatiaScreen = React.lazy(() => import( "../../screens/satia/main/virtualBank/action/ActionListVirtualBankSatiaScreen"));
// const HelpSoftwareSatiaScreen = React.lazy(() => import( "../../screens/satia/main/helpSoftware/HelpSoftwareSatiaScreen"));
// const InformationSatiaScreen = React.lazy(() => import( "../../screens/satia/login/information/action/ActionInformationSatiaScreen"));
// const IntroduceFriendsSatiaScreen = React.lazy(() => import( "../../screens/satia/main/introduceFriends/IntroduceFriendsSatiaScreen"));
// const FactorServiceHistorySatiaScreen = React.lazy(() => import( "../../screens/satia/main/listServiceHistory/FactorServiceHistorySatiaScreen"));
//
// import HomeScreen from "../../web/screens/HomeScreen";
// import SecondScreen from "../../web/screens/SecondScreen";
// import LoginEnterPhoneCodeSatiaScreen from "../../screens/satia/login/enterMobile/action/ActionLoginEnterPhoneCodeSatiaScreen";
// import EnterCodeSatiaScreen from "../../screens/satia/login/enterCode/action/ActionEnterCodeSatiaScreen";

enableScreens();

const theme = {
    ...NavigationDarkTheme,
    // ...PaperDarkTheme,
    colors: {
        ...NavigationDarkTheme.colors,
        // ...PaperDarkTheme.colors,
        background: '#f0f0f0',
        text: '#ffffff'
    }
};
const HomeStack = createStackNavigator();

function HomeStackScreen() {

    return (
        <HomeStack.Navigator
            initialRouteName="MainSatiaScreen"
            screenOptions={{
                headerTitleAlign: 'center',
                headerStyle: {
                    backgroundColor: '#621FF7',
                },
                headerTintColor: '#fff',
                headerTitleStyle: {
                    fontWeight: 'bold',
                },
                headerShown: false

            }}
        >
            <HomeStack.Screen
                //    options={{ title:"ahmad",path:'ahmad' }}

                name="MainSatiaScreen" component={MainSatiaScreen}/>

            <HomeStack.Screen name="ListServiceSatiaScreen" component={ListServiceSatiaScreen}/>
            <HomeStack.Screen name="ListGigSatiaScreen" component={ListGigSatiaScreen}/>
            <HomeStack.Screen name="PaySatiaScreen" component={PaySatiaScreen}/>
            <HomeStack.Screen name="ListMicroConsumptionSatiaScreen" component={ListMicroConsumptionSatiaScreen}/>
            <HomeStack.Screen name="ContactUsScreen" component={ContactUsScreen}/>
            <HomeStack.Screen name="TestConnectionScreen" component={TestConnectionScreen}/>
            <HomeStack.Screen name="ListHistoryTelephoneLineStatusSatiaScreen"
                              component={ListHistoryTelephoneLineStatusSatiaScreen}/>
            <HomeStack.Screen name="ListServiceHistorySatiaScreen" component={ListServiceHistorySatiaScreen}/>
            <HomeStack.Screen name="ListMessageSatiaScreen" component={ListMessageSatiaScreen}/>
            <HomeStack.Screen name="ListOnlineChargingHistorySatiaScreen"
                              component={ListOnlineChargingHistorySatiaScreen}/>
            <HomeStack.Screen name="ListMessageOperatorSatiaScreen" component={ListMessageOperatorSatiaScreen}/>
            <HomeStack.Screen name="ListQuestionAndAnswerSatiaScreen" component={ListQuestionAndAnswerSatiaScreen}/>

            <HomeStack.Screen name="ChangeInformationSatiaScreen" component={ChangeInformationSatiaScreen}/>
            <HomeStack.Screen name="ProfileSatiaScreen" component={ProfileSatiaScreen}/>
            <HomeStack.Screen name="UploadDocumentSatiaScreen" component={UploadDocumentSatiaScreen}/>
            <HomeStack.Screen name="ListAccountSatiaScreen" component={ListAccountSatiaScreen}/>
            <HomeStack.Screen name="ShowListMicroConsumptionSatiaScreen"
                              component={ShowListMicroConsumptionSatiaScreen}/>
            <HomeStack.Screen name="SatiaScreen" component={SatiaScreen}/>
            <HomeStack.Screen name="ChartSatiaScreen" component={ChartSatiaScreen}/>
            <HomeStack.Screen name="ShowMap" component={ShowMap}/>
            <HomeStack.Screen name="WebViewScreen" component={WebViewScreen}/>
            <HomeStack.Screen name="ListVirtualBankSatiaScreen" component={ListVirtualBankSatiaScreen}/>
            <HomeStack.Screen name="HelpSoftwareSatiaScreen" component={HelpSoftwareSatiaScreen}/>
            <HomeStack.Screen name="InformationSatiaScreen" component={InformationSatiaScreen}/>
            <HomeStack.Screen name="IntroduceFriendsSatiaScreen" component={IntroduceFriendsSatiaScreen}/>
            <HomeStack.Screen name="IntroduceFriendsChildSatiaScreen" component={IntroduceFriendsChildSatiaScreen}/>
            <HomeStack.Screen name="FactorServiceHistorySatiaScreen" component={FactorServiceHistorySatiaScreen}/>

            {/*Operation*/}
            <HomeStack.Screen name="TasksOperationSatiaScreen" component={TasksOperationSatiaScreen}/>
            <HomeStack.Screen name="AddTaskOperationSatiaScreen" component={AddTaskOperationSatiaScreen}/>
            <HomeStack.Screen name="ListTaskOperationSatiaScreen" component={ListTaskOperationSatiaScreen}/>
            <HomeStack.Screen name="DetailsTaskOperationSatiaScreen" component={DetailsTaskOperationSatiaScreen}/>
            <HomeStack.Screen name="HotSpotScreen" component={HotSpotScreen}/>
            <HomeStack.Screen name="IncreaseCreditSatiaScreen" component={IncreaseCreditSatiaScreen}/>

            {/*           <HomeStack.Screen  name='ahmad' component={() => {
                window.location.href = 'https://google.com';
                return null;
            }}/>*/}
            {/*  <HomeStack.Screen
                name='ahmad'
                component={ Redirect }
                loc="https://meetflo.zendesk.com/hc/en-us/articles/230425728-Privacy-Policies"
            />*/}

        </HomeStack.Navigator>
    );
};

const LoginStack = createStackNavigator();

function LoginStackScreen() {

    return (
        <LoginStack.Navigator
            initialRouteName="HomeScreen"
            screenOptions={{
                headerTitleAlign: 'center',
                headerStyle: {
                    backgroundColor: '#621FF7',
                },
                headerTintColor: '#fff',
                headerTitleStyle: {
                    fontWeight: 'bold',
                },
                headerShown: false
            }}

        >

            <LoginStack.Screen name="LoginEnterPhoneCodeSatiaScreen"
                               component={LoginEnterPhoneCodeSatiaScreen}/>
            <LoginStack.Screen name="LoginEnterUsernameSatiaScreen"
                               component={LoginEnterUsernameSatiaScreen}/>
            <LoginStack.Screen name="EnterCodeSatiaScreen"
                               component={EnterCodeSatiaScreen}/>
            <LoginStack.Screen name="InformationSatiaScreen"
                               component={InformationSatiaScreen}/>
            <LoginStack.Screen name="ListServiceSatiaScreen" component={ListServiceSatiaScreen}/>
            <LoginStack.Screen name="PaySatiaScreen" component={PaySatiaScreen}/>

            {/*
            <HomeStack.Screen name="SecondScreen" component={SecondScreen}/>
*/}

        </LoginStack.Navigator>
    );
};
/*const prefix = Linking.makeUrl("/");
const linking: LinkingOptions = {
    prefixes: [prefix],
    config: {
        screens: {
            HomeStack: {
                path: "stack",
                initialRouteName: "Home",
                screens: {
                    Home: "home",
                    Profile: {
                        path: "user/:id/:age",
                        parse: {
                            id: id => `there, ${id}`,
                            age: Number,
                        },
                        stringify: {
                            id: id => id.replace("there, ", ""),
                        },
                    },
                },
            },
            Settings: "settings",
        },
    },
};*/
/*
const config = {
    screens: {
        Chat: 'feed/:sort',
        Profile: 'user',
    },
};
const linking = {
    prefixes: ['https://mychat.com', 'mychat://'],
    config,
};
*/

const linking = {
    prefixes: [
        'https://app.example.com'
        /* your linking prefixes */
    ],
    config: {
        screens: {
            initialRouteName: 'SplashSatiaScreen',

            SplashSatiaScreen: 'splash',
            LoginStackScreen: 'login',
            ListAccountSatiaScreen: 'accounts',
            DrawerScreen: {

                path: 'drawer',
                screens: {
                    HomeStackScreen: {

                        path: 'home',
                        /*   screens: {
                               MainSatiaScreen: 'main',

                           }*/

                    }

                }

            },
            HelpSoftwareSatiaScreen_Root: {
                path: 'help_software_app',
                // parse: {
                //     id: (id) => `user-${id}`,
                // },
                // stringify: {
                //     id: (id) => id.replace(/^user-/, ''),
                // },
            },
            InformationSatiaScreen_Root: {
                path: 'r',
                // parse: {
                //     id: (id) => `user-${id}`,
                // },
                // stringify: {
                //     id: (id) => id.replace(/^user-/, ''),
                // },
            },
            ListServiceSatiaScreen_Root: {
                path: 'ListService',
                // parse: {
                //     id: (id) => `user-${id}`,
                // },
                // stringify: {
                //     id: (id) => id.replace(/^user-/, ''),
                // },
            },
            PaySatiaScreen_Root: {
                path: 'Pay',
                // parse: {
                //     id: (id) => `user-${id}`,
                // },
                // stringify: {
                //     id: (id) => id.replace(/^user-/, ''),
                // },
            },
            FactorServiceHistorySatiaScreen_Root: {
                path: 'print',
                // parse: {
                //     id: (id) => `user-${id}`,
                // },
                // stringify: {
                //     id: (id) => id.replace(/^user-/, ''),
                // },
            },
            /*

               DrawerScreen: {
                   path: 'drawer',
                   screens: {
                       HomeStackScreen: {
                           path: 'home',
                           screens: {

                               MainSatiaScreen: 'main',

                               ListServiceSatiaScreen:'services',


                               ListGigSatiaScreen: 'gigs',


                               PaySatiaScreen:  'pay',

                               ListMicroConsumptionSatiaScreen:  'internetUsage',

                               ContactUsScreen: 'contactUs',

                               TestConnectionScreen:  'testConnection',

                               ListHistoryTelephoneLineStatusSatiaScreen: 'lineStatus',
                               ListServiceHistorySatiaScreen:  'serviceHistory',
                               ListMessageSatiaScreen:'messages',
                               ListOnlineChargingHistorySatiaScreen:'chargingHistory',
                               ListMessageOperatorSatiaScreen:  'tickets',
                               ListQuestionAndAnswerSatiaScreen:'questions',
                               ChangeInformationSatiaScreen: 'changeInformation',
                               ProfileSatiaScreen: 'profile',
                               UploadDocumentSatiaScreen:  'upload',
                               ListAccountSatiaScreen:'accounts',
                               ShowListMicroConsumptionSatiaScreen:  'detailsInternetUsage',

                               SatiaScreen:  'satia',

                               ChartSatiaScreen: 'chart',
                               ShowMap:  'map',
                               WebViewScreen: 'web',


                               /!*



               <HomeStack.Screen name="WebViewScreen" component={WebViewScreen}/>
               *!/
                           }
                       },
                   }
               },*/

        }

    },

    // getStateFromPath: (path, options) => {
    //     // Return a state object here
    //     // You can also reuse the default logic by importing `getStateFromPath` from `@react-navigation/native`
    // },
    // getPathFromState(state, config) {
    //
    //     // Return a path string here
    //     // You can also reuse the default logic by importing `getPathFromState` from `@react-navigation/native`
    // },
};

const Drawer = createDrawerNavigator();
const DrawerScreen = () => (
    <Drawer.Navigator
        initialRouteName="HomeStackScreen"
        screenOptions={{

            headerShown: false
        }}

        drawerContent={props => <MenuDrawerSatia {...props}

        />}>


        {/*<Drawer.Screen name="MainSatiaScreen" component={MainSatiaScreen}/>*/}
        <Drawer.Screen name="HomeStackScreen" component={HomeStackScreen}/>


        {/*    <Drawer.Screen name="HomeDrawer" component={HomeScreen}/>
        <Drawer.Screen name="SupportScreen" component={SecondScreen}/>*/}
        {/*<Drawer.Screen name="UserScreen" component={UserScreen}/>*/}
        {/*<Drawer.Screen name="HomeScreen" component={HomeScreen}/>*/}
    </Drawer.Navigator>
);
const RootStack = createStackNavigator();

function Home() {
    return (
        <Tab.Navigator>

            <Tab.Screen name="Profile" component={HomeScreen}/>
            <Tab.Screen name="Feed" component={SecondScreen}/>
        </Tab.Navigator>
    );
}

const SplashStack = createStackNavigator();
const Tab = createBottomTabNavigator();
let token = null;

/*const storage = Platform.select({
    web: () => require("localforage"),
    android: () => require("@react-native-community/async-storage").default,
    ios: () => require("@react-native-community/async-storage").default
})();*/
class RouterSatia extends PureComponent {
    async componentWillMount() {

        token = await AsyngStorageClass.checkToken();
        store.dispatch(serviceActionSetToken(token));
        if (token) {
            let user = await AsyngStorageClass.getASyng(typeExport._USER);
            store.dispatch(serviceActionSetUser(user))

            let account = await AsyngStorageClass.getASyng("Account");
            store.dispatch(serviceActionAccount(account, 0));
        }


        let token_fb = await AsyncStorage.getItem('fcmToken');

        store.dispatch(serviceActionTokenFirebase(token_fb));


        // store.dispatch(serviceActionSetTypeLogin(typeExport._TypeLogin, t)


    }

    componentWillReceiveProps(props) {

    }

    async componentDidMount() {

        if (Platform.OS === "android") {
            let storage = await AsyngStorageClass.getASyng(typeExport._UserPassWifi);
            store.dispatch(serviceActionSetUserPassWifi(storage))
        }

        let Conn = false;

        const dispatchConnected = state => {
            let isConnected = state.isConnected
            // this.props.setIsConnected(isConnected);
            store.dispatch(serviceActionSetIsConnected(isConnected))
            store.dispatch(serviceActionSetConnectionType(state))

            if (Platform.OS === "android")
                this.checkSatusWifi()
            Conn = isConnected;

        }


        NetInfo.addEventListener(dispatchConnected);

    }

    checkSatusWifi() {

        wifi.isEnabled((isEnabled) => {
            store.dispatch(serviceActionSetwifiIsEnabled(isEnabled))


            console.log("**wifi service enabled");
            wifi.connectionStatus((isConnected) => {

                store.dispatch(serviceActionSetwifiConnectionStatus(isConnected))

                axios(
                    {
                        //    url: `http://h.1547.ir/login?username=091895610009&password=863265`,
                        //  url: `http://h.1547.ir/login?username=09189648119&password=13981398`,
                        url: `https://google.com`,
                        method: "GET",
                        timeout: 3000,
                        headers: {
                            'Content-Type': 'text/html',
                        },
                    })
                    .then(async response => {
                        console.log("response", response);
                        let data = response.data;

                        store.dispatch(serviceActionSetConnectionInternetHotspot((response && response.status === 200)))
                    })
                    .catch((e) => {
                        store.dispatch(serviceActionSetConnectionInternetHotspot(false))
                        this.setState({
                            isConnectionGoogle: false,
                            // wifiConnectionStatus: true,

                        })
                        console.log("errorrequestLogin", e);
                    })

            });

        });

    }

    render() {
        return (


            <View style={[{position: 'absolute', top: 0, bottom: 0, right: 0, left: 0}]}>
                <React.Suspense fallback={<HMLoading/>}>

                    <NavigationContainer ref={navigationRef} theme={theme} linking={linking}>
                        {/*
                        <HomeStackScreen/>
*/}
                        <RootStack.Navigator headerMode="none" initialRouteName="SplashScreen"
                                             documentTitle={{
                                                 formatter: (options, route) =>
                                                     //     `${options?.title ?? route?.name} - My Cool App`,
                                                     `${i18n.t('appName')}`,
                                             }}

                        >

                            {/*   <RootStack.Screen
                                name="Drawer"
                                component={DrawerScreen}
                                options={{
                                    animationEnabled: false
                                }}
                            />
*/}
                            {
                                // //  !this.props.resultsSatia ||  !this.props.results?
                                // !this.props.results ?
                                //
                                //     <RootStack.Screen name="SplashSatiaScreen" component={SplashSatiaScreen}/>
                                //     :
                                //     !this.props.token ?
                                //         <RootStack.Screen
                                //             //options={{headerShown: false}}
                                //             name="LoginStackScreen"
                                //             component={LoginStackScreen}/>
                                //         :
                                //         !this.props.Account ?
                                //             <RootStack.Screen name="ListAccountSatiaScreen"
                                //                               component={ListAccountSatiaScreen}/>
                                //             :
                                //             <RootStack.Screen options={{headerShown: false}} name="DrawerScreen"
                                //                               component={DrawerScreen}/>
                            }


                            {
                                //  !this.props.resultsSatia ||  !this.props.results?

                                    !this.props.token ?
                                        <RootStack.Screen
                                            //options={{headerShown: false}}
                                            name="LoginStackScreen"
                                            component={LoginStackScreen}/>
                                        :
                                        (

                                            !this.props.results ?

                                                <RootStack.Screen name="SplashSatiaScreen" component={SplashSatiaScreen}/>
                                                :
                                                (
                                                    !this.props.Account ?
                                                        <RootStack.Screen name="ListAccountSatiaScreen"
                                                                          component={ListAccountSatiaScreen}/>
                                                        :
                                                        <RootStack.Screen options={{headerShown: false}} name="DrawerScreen"
                                                                          component={DrawerScreen}/>
                                                )
                                        )

                            }
                            <RootStack.Screen name="HelpSoftwareSatiaScreen_Root" component={HelpSoftwareSatiaScreen}/>
                            <RootStack.Screen name="InformationSatiaScreen_Root" component={InformationSatiaScreen}/>
                            <RootStack.Screen name="ListServiceSatiaScreen_Root" component={ListServiceSatiaScreen}/>
                            <RootStack.Screen name="PaySatiaScreen_Root" component={PaySatiaScreen}/>
                            <RootStack.Screen name="FactorServiceHistorySatiaScreen_Root"
                                              component={FactorServiceHistorySatiaScreen}/>


                        </RootStack.Navigator>

                    </NavigationContainer>
                </React.Suspense>
            </View>

        );
    }
}

const mapStateToProps = state => ({
    token: state.reducerSplashSatiaScreen.token,
    resultsSatia: state.reducerSplashSatiaScreen.resultsSatia,
    results: state.reducerSplashSatiaScreen.results,
    user: state.reducerSplashSatiaScreen.user,
    Account: state.reducerSplashSatiaScreen.Account,

});

export default connect(
    mapStateToProps,
    {}
)(RouterSatia);
